import { useColorScheme } from './ColorSchemeContext';

export function ColorSchemeToggle({ className = '' }: { className?: string }) {
  const { scheme, toggle } = useColorScheme();
  const isDark = scheme === 'dark';

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Passer en mode clair' : 'Passer en mode sombre'}
      aria-pressed={isDark}
      className={`flex items-center gap-1 rounded-full border border-manuscript-line-strong p-1 text-xs font-bold ${className}`}
    >
      <span
        className={`rounded-full px-2 py-1 transition-colors ${
          isDark ? 'text-manuscript-ink-faint' : 'bg-manuscript-gold-400 text-manuscript-ink'
        }`}
      >
        ☀
      </span>
      <span
        className={`rounded-full px-2 py-1 transition-colors ${
          isDark ? 'bg-manuscript-gold-400 text-manuscript-ink' : 'text-manuscript-ink-faint'
        }`}
      >
        ☾
      </span>
    </button>
  );
}
